// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"460":"4c1c797c","473":"0e13025f","570":"8e8913f1","807":"0e13025f","918":"9719b2f3"}[chunkId] + ".css";
};